import React, { useState, useMemo } from 'react';
import moment from 'moment';
import MUIDataTable from 'mui-datatables';

import CustomToolbar from 'components/CustomToolbar/CustomToolbar';
import VendorInfoModal from 'components/Vendors/VendorInfoModal';
import VendorProcessModal from 'components/Vendors/VendorProcessModal';
import ExpectedExpenseModal from 'components/Vendors/ExpectedExpenseModal';

const VendorsTable = (props) => {

  const [rowsSelected, setRowsSelected] = useState([]);
  
  const [openExpectedModal, setOpenExpectedModal] = useState(false);
  const [openProcessModal, setOpenProcessModal] = useState(false);
  const [openInfoModal, setOpenInfoModal] = useState(false);
  const [vendorInfo, setVendorInfo] = useState({});

  const tableData = useMemo(() => {
    const initialTableData = [];

    for ( let i = 0; i < props.vendors.length; i++ ) {
      const vendor = props.vendors[i];
      initialTableData.push({
        id: vendor.id,
        displayId: vendor.displayId,
        name: vendor.name,
        phone: vendor.phone,
        department: vendor.department,
        date: moment(vendor.joiningDate).format('DD/MM/YYYY')
      });
    }

    return initialTableData;
  
  }, [props.vendors]);

  const columns = [
    { label: "ID", name: "displayId" },
    { label: "Vendor Name", name: "name"},
    { label: "Phone", name: "phone" },
    { label: "Department", name: "department" },
    { label: "Joining Date", name: "date" }
  ];

  const closeInfoModal = () => {
    setOpenInfoModal(false);
    setVendorInfo({});
  };

  const handleProcessModalOpen = () => {
    setOpenProcessModal(true);
  };

  const closeProcessModal = () => {
    setOpenProcessModal(false);
    setRowsSelected([]);
  };

  const updateExpectedExpense = () => {
    setOpenExpectedModal(true);
  };

  const closeExpectedExpenseModal = () => {
    setOpenExpectedModal(false);
    setRowsSelected([]);
  };

  const onRowSelectionChange = (curr, all, rowsSelected) => {
    setRowsSelected(rowsSelected);
    if(rowsSelected.length === 1) {
      const vendorInfo = props.vendors[rowsSelected[0]];
      props.setUpdateInfo({
        id: vendorInfo.id,
        name: vendorInfo.name,
        phone: vendorInfo.phone,
        department: vendorInfo.department,
        joiningDate: moment(vendorInfo.joiningDate).format('YYYY-MM-DD')
      });
    }
  };

  const customToolbarSelect = () => {
    return (
      <CustomToolbar
        switchy={3}
        isVendor={true}
        setUpdate={props.updateVendor}
        handleProcessModalOpen={handleProcessModalOpen}
        updateExpected={updateExpectedExpense}
      />
    )
  };

  const options = {
    filterType: 'dropdown',
    selectableRows: 'single',
    selectableRowsOnClick: false,
    rowsSelected,
    onRowSelectionChange,
    customToolbarSelect,
    setRowProps: (row, dataIndex, rowIndex) => ({
      onDoubleClick: () => {
        if(!rowsSelected[0]) {
          setVendorInfo(props.vendors[dataIndex]);
          setOpenInfoModal(true);
        }
      }
    })
  };

  return (
    <React.Fragment>
      <MUIDataTable
        title={"Vendor List"}
        data={tableData}
        columns={columns}
        options={options}
      />
      { openInfoModal ?
      <VendorInfoModal
        open={openInfoModal}
        vendorInfo={vendorInfo}
        expenses={props.expenses}
        closeModal={closeInfoModal}
      />
      : null }
      { openProcessModal ?
      <VendorProcessModal
        open={openProcessModal}
        products={props.products}
        processes={props.processes}
        user={props.user}
        vendorId={tableData[rowsSelected[0]].id}
        closeModal={closeProcessModal}
      />
      : null }
      { openExpectedModal ?
      <ExpectedExpenseModal
        open={openExpectedModal}
        vendorId={tableData[rowsSelected[0]].id}
        closeModal={closeExpectedExpenseModal}
      />
      : null }
    </React.Fragment>
  )
};

export default VendorsTable;